module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_detail clearfix p_background"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("应用名称")]), _vm._v(" "), _c('section', {
    staticClass: "app_detail_box tb_padding container_box clearfix"
  }, [_c('div', {
    staticClass: "state_right text-right",
    staticStyle: {
      "width": "95%"
    }
  }, [(_vm.filterFlag1) ? _c('span', {
    staticClass: "btn btn_issue",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "editBtn"
    },
    on: {
      "click": function($event) {
        return _vm.editAppCloud(_vm.appCloud.id, _vm.vId)
      }
    }
  }, [_vm._v("编辑信息")]) : _vm._e(), _vm._v(" "), (_vm.filterFlag) ? _c('span', {
    staticClass: "btn btn_issue",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "deployBtn"
    },
    on: {
      "click": function($event) {
        return _vm.updateAppCloud(_vm.appCloud.id, _vm.vId)
      }
    }
  }, [_vm._v("更新版本")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details_title_box clearfix"
  }, [_c('div', {
    staticClass: "photo_left inline-block"
  }, [_c('div', {
    staticClass: "photo_info",
    staticStyle: {
      "width": "160px",
      "height": "160px",
      "border-radius": "32px"
    }
  }, [_c('div', {
    staticClass: "img_default hidden"
  }), _vm._v(" "), _c('img', {
    staticClass: "img_default",
    attrs: {
      "src": _vm.logoPath,
      "id": "app_icon_first",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("版本编号：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.versionNo))])]), _vm._v(" "), _c('div', {
    staticClass: "intro_right inline-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.appCloud.appName))]), _vm._v(" "), _c('div', {
    staticClass: "right_box clearfix"
  }, [_c('section', {
    staticClass: "col-sm-6 right_box_left"
  }, [_c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("应用状态：")]), _vm._v(" "), (_vm.appCloud.appStatus == '3') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("禁止销售")]) : (_vm.showStatus == '9') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("准备提交")]) : (_vm.showStatus == '0') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("等待审核")]) : (_vm.showStatus == '3') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("正在审核")]) : (_vm.showStatus == '2') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("审核被拒")]) : (_vm.showStatus == '1' && _vm.showPublicStatus == '0') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("等待上架")]) : (_vm.showStatus == '1' && _vm.showPublicStatus == '1' && _vm.appCloud.appStatus == '1') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("可供销售")]) : (_vm.appCloud.appStatus == '2') ? _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("暂停销售")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("上线日期：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.appCloud.tcloudAppVersion.publishTime ? _vm.appCloud.tcloudAppVersion.publishTime : '')))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("应用分类：")]), _vm._v(" "), _vm._l((_vm.appTypeOptions), function(option) {
    return (_vm.appCloud.businessType == option.id) ? _c('span', {
      staticClass: "intro_text inline-block"
    }, [_vm._v(_vm._s(option.dictionaryname))]) : _vm._e()
  })], 2), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("群体范围：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.userScope))])])]), _vm._v(" "), _c('section', {
    staticClass: "col-sm-6 right_box_right"
  }, [_c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("增值服务：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.addserviceApis))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("数据接口权限：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.misdataApis))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details_presentation_box word-bw"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("应用介绍：")]), _vm._v(" "), _c('p', {
    staticClass: "color_9"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.appComment))])]), _vm._v(" "), _c('div', {
    staticClass: "details_record_box"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("审核记录：")]), _vm._v(" "), (_vm.appVersionAuditList.length > 0) ? _c('section', _vm._l((_vm.appVersionAuditList), function(audit) {
    return _c('p', {
      staticClass: "color_9 line_block cursor"
    }, [_c('span', {
      staticClass: "time text-space"
    }, [_vm._v(_vm._s(_vm._f("time")(audit.inputTime ? audit.inputTime : '')))]), _vm._v(" "), _c('span', {
      staticClass: "name text-space",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "管理员【名称v.1.0.1】"
      }
    }, [_vm._v(_vm._s(audit.inputUser) + "【" + _vm._s(audit.appname) + " " + _vm._s(audit.versionno) + "】")]), _vm._v(" "), (audit.inspectStatus == '2') ? _c('span', {
      staticClass: "state state_not"
    }, [_vm._v("不通过")]) : _vm._e(), _vm._v(" "), (audit.inspectStatus == '1') ? _c('span', {
      staticClass: "state state_success"
    }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "text text-space",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": audit.inspectComment
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(audit.inspectComment) + "\n\t\t\t\t\t")])])
  }), 0) : _c('section', [_c('p', {
    staticClass: "color_9"
  }, [_vm._v("    暂无审核记录")])])]), _vm._v(" "), _c('div', {
    staticClass: "details_screenshot_box"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("屏幕截图：")]), _vm._v(" "), _c('el-carousel', {
    attrs: {
      "interval": 4000,
      "type": "card",
      "height": "300px"
    }
  }, _vm._l((_vm.appCloudFiles), function(pic, index) {
    return _c('el-carousel-item', {
      key: pic.appCloudFiles
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": pic.filePath
      }
    })])])
  }), 1)], 1), _vm._v(" "), (_vm.appCloudCommentPage.length > 0) ? _c('div', {
    staticClass: "details_feedback_box"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("反馈评论：")]), _vm._v(" "), _c('p', {
    staticClass: "sub_title h6 cursor"
  }, [_vm._v("全部评论"), _c('span', [_vm._v("(" + _vm._s(_vm.appCloudCommentPage.length) + ")")])]), _vm._v(" "), _c('ul', {
    staticClass: "feedback_list"
  }, _vm._l((_vm.filterCommentList), function(comment) {
    return _c('li', [_vm._m(1, true), _vm._v(" "), _c('section', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "content_title clearfix tip_sub_text"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_c('span', [_vm._v("用户名")]), _vm._v(" "), _c('i', {
      staticClass: "star"
    }, [_vm._v(_vm._s(comment.userName))])]), _vm._v(" "), _c('small', {
      staticClass: "pull-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t评论版本：\n\t\t\t\t\t\t\t\t"), _c('b', [_vm._v(_vm._s(comment.versionNo))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("time")(comment.commentTime)))])])]), _vm._v(" "), _c('p', {
      staticClass: "h6 color_9"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(comment.comment) + "\n\t\t\t\t\t\t")])])])
  }), 0), _vm._v(" "), (_vm.appCloudCommentPage.length > 5) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("查看更多")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageNumber),
      expression: "pageNumber"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.pageNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pageNumber = $event.target.value
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("部署类型：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v("私有云部署")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "head_img"
  }, [_c('div', {
    staticClass: "head_img_box center-block img-circle"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-50b39990"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/app_detail.vue
// module id = 1258
// module chunks = 1